const mutations = {
  SET_CONTACT: (state, payload) => {
    state.contact = payload;
  },
};

export { mutations };
